/* eslint-disable react/prop-types */
import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { Tabs } from 'antd';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import Details from '../components/Details';
import ITP from '../components/ITP';
import LogDetails from '../components/LogDetails';
import DPRSettingsTeamsTab from '../components/DPR/DPRSettingsTeamsTab';
import MaterialConsumption from '../components/MaterialConsumption';
import DPRSettingsConsumablesTab from '../components/DPR/DPRSettingsConsumablesTab';
import Equipment from '../components/Equipment';
import DSR from '../components/DSR';
import DPR from '../components/DPR';
import ToolboxHome from '../components/ToolboxHome';
import SpareDashboard from '../components/SpareDashboard';
import FabricationDashboard from '../components/Fabrication/FabricationDashboard';
import DPRSettingsReportingEmailTab from '../components/DPR/DPRSettingsReportingEmailTab';
// import InvoiceAndBilling from '../components/InvoiceAndBilling'; // Billing tab hidden from project tabs UI
import PQTDetailsPage from '../components/PQT/PQTDetailsPage';
import ShipmentDashBoardPage from '../components/ShippingManagement/ShipmentDashBoardPage';
import { DEFAULT_TEAM_MEMBER_TABS } from '../utils/teamMemberConfig';

import '../pages/calibration/CalibrationPage.css';
import '../pages/admin/AdminModernPage.css';
import './ProjectTabsStrip.css';

const { TabPane } = Tabs;

const TabList = (props) => {
  const {
    selectedProject,
    stationList,
    testTypesList,
    setStationList,
    equipmentList,
    selectedData,
    projectTeamMembersAccessList,
    userAccessList,
  } = props;

  // Always display all default tabs (including DSR, PQT) on home/dashboard
  const visibleTabs = DEFAULT_TEAM_MEMBER_TABS;
  const [filteredTabs, setFilteredTabs] = useState([]);

  const [showPQTTestPage, setShowPQTTestPage] = useState(false);
  const [activeTab, setActiveTab] = useState('1');

  // Check if the user has admin access
  const isAdmin = userAccessList.includes('admin') || userAccessList.includes('super-admin');

  // Memoize allTabs to prevent recreation on every render
  const allTabs = useMemo(
    () => [
      {
        key: '1',
        tab: 'Details',
        component: <Details selectedProject={selectedProject} userAccessList={userAccessList} />,
      },
      {
        key: '2',
        tab: 'Equipment',
        component: (
          <Equipment
            selectedProject={selectedProject}
            equipmentList={equipmentList}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '14',
        tab: 'Shipment',
        component: (
          <ShipmentDashBoardPage
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '10',
        tab: 'Spares',
        component: (
          <SpareDashboard
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '16',
        tab: 'Fabrication',
        component: (
          <FabricationDashboard
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '3',
        tab: 'Consumables',
        component: <DPRSettingsConsumablesTab selectedProject={selectedProject} />,
      },
      {
        key: '4',
        tab: 'Material Consumption',
        component: (
          <MaterialConsumption
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '5',
        tab: 'Team',
        component: <DPRSettingsTeamsTab selectedProject={selectedProject} />,
      },
      {
        key: '11',
        tab: 'Reporting Email',
        component: <DPRSettingsReportingEmailTab selectedProject={selectedProject} />,
      },
      {
        key: '6',
        tab: 'Log',
        component: (
          <LogDetails
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '7',
        tab: 'ITP',
        component: (
          <ITP
            stationList={stationList}
            selectedProject={selectedProject}
            testTypesList={testTypesList}
            setStationList={setStationList}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '13',
        tab: 'PQT',
        component: (
          <PQTDetailsPage
            selectedProject={selectedProject}
            stationList={stationList}
            testTypesList={testTypesList}
            setStationList={setStationList}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
            showPQTTestPage={showPQTTestPage}
            setShowPQTTestPage={setShowPQTTestPage}
          />
        ),
      },
      // Billing tab — hidden from UI (restore block + import to show again)
      // {
      //   key: '12',
      //   tab: 'Billing',
      //   component: (
      //     <InvoiceAndBilling
      //       selectedProject={selectedProject}
      //       projectTeamMembersAccessList={projectTeamMembersAccessList}
      //       userAccessList={userAccessList}
      //     />
      //   ),
      // },
      {
        key: '8',
        tab: 'DSR',
        component: (
          <DSR
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
      {
        key: '15',
        tab: 'DPR',
        component: (
          <DPR
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
        openInNewTab: true, // Flag to indicate this tab should open in new tab
      },
      {
        key: '9',
        tab: 'Communications',
        component: (
          <ToolboxHome
            selectedProject={selectedProject}
            projectTeamMembersAccessList={projectTeamMembersAccessList}
            userAccessList={userAccessList}
          />
        ),
      },
    ],
    [
      selectedProject,
      equipmentList,
      projectTeamMembersAccessList,
      userAccessList,
      stationList,
      testTypesList,
      setStationList,
    ]
  );

  useEffect(() => {
    const newFilteredTabs = isAdmin
      ? allTabs
      : allTabs.filter((tab) => visibleTabs.includes(tab.tab));
    setFilteredTabs(newFilteredTabs);
  }, [visibleTabs, isAdmin, allTabs]);

  const tabsViewportRef = useRef(null);
  const [tabScrollState, setTabScrollState] = useState({
    hasOverflow: false,
    canPrev: false,
    canNext: false,
  });

  const updateTabScrollEdges = useCallback(() => {
    const el = tabsViewportRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    const hasOverflow = scrollWidth > clientWidth + 2;
    setTabScrollState({
      hasOverflow,
      canPrev: hasOverflow && scrollLeft > 2,
      canNext: hasOverflow && scrollLeft < scrollWidth - clientWidth - 2,
    });
  }, []);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      updateTabScrollEdges();
    });
    return () => cancelAnimationFrame(id);
  }, [filteredTabs, updateTabScrollEdges]);

  useEffect(() => {
    const el = tabsViewportRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => {
      updateTabScrollEdges();
    });
    ro.observe(el);
    return () => {
      ro.disconnect();
    };
  }, [updateTabScrollEdges, filteredTabs.length]);

  const scrollTabsBy = (direction) => {
    const el = tabsViewportRef.current;
    if (!el) return;
    const delta = Math.min(280, Math.max(120, Math.floor(el.clientWidth * 0.75)));
    el.scrollBy({ left: direction * delta, behavior: 'smooth' });
  };

  const handleTabChange = (key) => {
    const tab = filteredTabs.find((t) => t.key === key);
    
    // If DPR tab is clicked, open in new tab
    if (tab && tab.openInNewTab && tab.tab === 'DPR') {
      const projectId = selectedProject && selectedProject.id ? selectedProject.id : '';
      const activeId = sessionStorage.getItem('activeId') || projectId;
      const dprUrl = `/dpr${activeId ? `?projectId=${activeId}` : ''}`;
      window.location.href = dprUrl;
      return; 
    }
    
    // Normal tab change for other tabs
    setActiveTab(key);
  };

  const { hasOverflow, canPrev, canNext } = tabScrollState;

  return (
    <div>
      <div
        className={`calibration-tabs-container modern-admin-tabs project-tabs-strip${!hasOverflow ? ' project-tabs-strip--no-overflow' : ''}`}
        style={{ marginBottom: '12px' }}
      >
        <div className="project-tabs-strip__row">
          <button
            type="button"
            className="project-tabs-strip__btn project-tabs-strip__btn--prev"
            onClick={() => scrollTabsBy(-1)}
            disabled={!hasOverflow || !canPrev}
            aria-label="Scroll project tabs left"
          >
            <ChevronLeft size={22} strokeWidth={2} aria-hidden />
          </button>
          <div
            className="project-tabs-strip__viewport"
            ref={tabsViewportRef}
            onScroll={updateTabScrollEdges}
            role="presentation"
          >
            <div className="calibration-tabs">
              {filteredTabs.map((tab) => (
                <div
                  key={tab.key}
                  className={`calibration-tab-item ${activeTab === tab.key ? 'active' : ''}`}
                  onClick={() => handleTabChange(tab.key)}
                >
                  {tab.tab}
                </div>
              ))}
            </div>
          </div>
          <button
            type="button"
            className="project-tabs-strip__btn project-tabs-strip__btn--next"
            onClick={() => scrollTabsBy(1)}
            disabled={!hasOverflow || !canNext}
            aria-label="Scroll project tabs right"
          >
            <ChevronRight size={22} strokeWidth={2} aria-hidden />
          </button>
        </div>
      </div>
      <div>
        {/*
          Mount only the active tab. Previously every tab was mounted and hidden with display:none,
          so each tab's useEffect ran on project open (duplicate /sows, pqt-sows, users, etc.).
        */}
        {filteredTabs.map((tab) =>
          activeTab === tab.key ? (
            <div key={tab.key} className="project-tab-panel project-tab-panel--active" style={{ position: 'relative' }}>
              {tab.component}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ equip }) => ({
  userAccessList: get(equip, 'userAccessList', []),
});

export default connect(mapStateToProps)(TabList);
